import { render, staticRenderFns } from "./ColOperationRecord.vue?vue&type=template&id=0496f788&scoped=true&"
import script from "./ColOperationRecord.vue?vue&type=script&lang=js&"
export * from "./ColOperationRecord.vue?vue&type=script&lang=js&"
import style0 from "./ColOperationRecord.vue?vue&type=style&index=0&id=0496f788&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0496f788",
  null
  
)

export default component.exports